import { Link } from "react-router-dom";
import { MapPin, Mail, Clock } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-white/10 bg-coal" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <span className="block w-10 h-10 rounded-full overflow-hidden border border-white/20">
              <img src="/logo.jpg" alt="Movimiento Church" className="w-full h-full object-cover scale-[1.65]" />
            </span>
            <span className="text-sm tracking-[0.3em] uppercase font-semibold">Movimiento Church</span>
          </div>
          <p className="font-display text-2xl font-light text-white/70 leading-snug max-w-sm">
            {t.footer.tagline}
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.25em] text-sand mb-6">{t.footer.nav}</p>
          <div className="flex flex-col gap-3 text-sm text-white/60">
            <Link to="/historia" className="hover:text-white transition-colors duration-300" data-testid="footer-link-historia">{t.nav.historia}</Link>
            <Link to="/ministerios" className="hover:text-white transition-colors duration-300" data-testid="footer-link-ministerios">{t.nav.ministerios}</Link>
            <Link to="/sermones" className="hover:text-white transition-colors duration-300" data-testid="footer-link-sermones">{t.nav.sermones}</Link>
            <Link to="/eventos" className="hover:text-white transition-colors duration-300" data-testid="footer-link-eventos">{t.nav.eventos}</Link>
            <Link to="/donar" className="hover:text-white transition-colors duration-300" data-testid="footer-link-donar">{t.nav.donar}</Link>
          </div>
        </div>
        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-[0.25em] text-sand mb-6">{t.footer.contact}</p>
          <div className="flex flex-col gap-4 text-sm text-white/60">
            <span className="flex items-start gap-3">
              <MapPin size={16} className="text-ember mt-0.5 shrink-0" />
              {t.footer.address}
            </span>
            <span className="flex items-start gap-3">
              <Clock size={16} className="text-ember mt-0.5 shrink-0" />
              {t.footer.services}
            </span>
            <span className="flex items-start gap-3">
              <Mail size={16} className="text-ember mt-0.5 shrink-0" />
              {t.footer.email}
            </span>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/40 tracking-wide">
        © {year} {t.footer.rights}
      </div>
    </footer>
  );
};
